'use strict';
angular.module('editCenterAtlas', ['mgcrea.ngStrap.button', 'atlasMultiImagesUploaderModule']).controller('EditCenterAtlasController', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$window',
    '$filter',
    '$q',
    '$timeout',
    '$validation',
    '$state',
    'trsHttpService',
    'initAddMetaDataService',
    'jsonArrayToStringService',
    'modalDialog',
    'initeditctrBtnsService',
    'editingCenterAppService',
    'editingCenterService',
    'storageListenerService',
    'initAppRequiredBtnService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'trsspliceString',
    'editIsLock',
    'editPictureService',
    'trsSelectDocumentService',
    'sensitiveWordCheckService',
    'editcenterRightsService',
    'editingMediatype',
    'globleParamsSet',
    '$sessionStorage',
    'newMediaService',
    'appConst',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $window,
        $filter,
        $q,
        $timeout,
        $validation,
        $state,
        trsHttpService,
        initAddMetaDataService,
        jsonArrayToStringService,
        modalDialog,
        initeditctrBtnsService,
        editingCenterAppService,
        editingCenterService,
        storageListenerService,
        initAppRequiredBtnService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        trsspliceString,
        editIsLock,
        editPictureService,
        trsSelectDocumentService,
        sensitiveWordCheckService,
        editcenterRightsService,
        editingMediatype,
        globleParamsSet,
        $sessionStorage,
        newMediaService,
        appConst,
        messagePublishService
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description]初始化稿件状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                pictureSize: {},
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                uploaderImgSelected: [],
                openBtn: true,
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                isSecondReview: false,
                isSignedOrRevoked: false,
                audioVideoidsArray: [],
                isEditDraft: !!$state.params.appmetadataid,
                position: $state.params.appplatform,
                heimaCheckTit: '错别字校对',
                uploadingZJSJ: {},
                isFusionEditor: $state.current.name == 'fusionatlas', // 是否来自融合编辑器
                isawaitrevise: $state.params.isawaitrevise,
                mediaType: editingMediatype.app,
                appmetadataid: $state.params.appmetadataid,
            };
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            $scope.data = {
                specialDoc: 0,
                userName: '',
                trench: appConst.params.listenStroageKey,
                copyVersion: [],
                relNewsSelectedItems: [],
                relSubjectSelectedItems: [],
                relSubjectGroup: [], // 相关专题分组
                relSubjectSelectedGroup: [], // 相关专题所选分组
                selectNewArray: [], // 相关图集选中数据
                selectSubjectArray: [], // 相关专题选中数据
                listStyle: editingCenterAppService.initListStyle('addZTPIC'),
                label: '',
                commentSet: editingCenterAppService.initCommentSet(),
                contributorsOne: editingCenterAppService.initContributorsOne(),
                docGenre: editingCenterAppService.initDocGenre(),
                KEYWORDS: [],
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                selectedVideoArray: [], // 选择的视频
                commonAuthor: [
                    {
                        text: '记者',
                    },
                    {
                        text: '编辑',
                    },
                    {
                        text: '通讯员',
                    },
                ], // 常用作者类型
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                listPicRatio: {
                    set: {
                        0: '',
                        1: '',
                        2: '',
                    },
                    practical: {
                        0: '1',
                        1: '1',
                        2: '1',
                    },
                },
                focusRatio: {
                    set: '',
                    practical: '1',
                },
                bigPicRtion: {
                    set: '', // 大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                },
                specZtPicRtion: {
                    set: '', // 窄图
                },
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getAPPFusionDoc',
                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            } else {
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'getPicsDoc',
                    ChnlDocId: $state.params.appchnldocid,
                };
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
            // 初始化标签
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.data.label = angular.copy(list);
            });
            $scope.editFlag = {
                media: 'app',
                docType: 'atlas',
            };
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.atlasForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     if ($scope.list.ISSECONDREVIEW != '1' || $scope.status.isSignedOrRevoked === false) {
            //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.appmetadataid }));
            //     }
            // };
            editingCenterService.allAppCloseWindow($scope, { typeName: 'app', saveLocal: false, hascondition: true });
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // 判断是否有修订完成权限
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                    $scope.status.btnRights = rights;
                });
            }
            if (!$scope.status.isFusionEditor) {
                (angular.isDefined($state.params.appchnldocid) ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                    getSiteConfig();
                });
                initBtnArray();
                getCutPictureWidthHeight();
            } else {
                getFusionEditorCutPictureWidthHeight();
            }
            // 融合编辑器下获取评审意见
            if ($state.params.iwometadataid) {
                getComment($state.params.iwometadataid, $scope.data.comment.currPage);
            }
            loadDirective();
        }

        /**
         * [getComment description]获取评审意见
         *
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         *
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                    $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getZrbj description]责任编辑赋值
         *
         * @return  {[type]}  [return description]
         */
        function getZrbj() {
            let trueName = $sessionStorage.get('curUserInfo').TRUENAME;
            $scope.list.RESPONSIBLEEDITOR = $scope.list.RESPONSIBLEEDITOR ? $scope.list.RESPONSIBLEEDITOR : trueName;
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function () {
            $scope.data.comment.currPage += 1;
            getComment($state.params.iwometadataid, $scope.data.comment.currPage);
        };

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            editingCenterService.querySettedPicSize('app').then(function (data) {
                var pictureSizeArr = [
                    'PICSIZE', // 列表图尺寸
                    'PICBIGSIZE', // 大图尺寸
                    'FOCUSIMAGESIZE', // 焦点图尺寸
                    'PICZTPICSIZE', // 窄图
                ];
                var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr, data);
                // 将返回来的值进行复制到本身控制器里显示
                dealPictureSize(pictureSizeArr, pictureSizeObj);
            });
            // var params = {
            //     serviceid: 'mlf_appconfig',
            //     methodname: 'getPicsSize',
            //     objectid: $state.params.appsiteid,
            // };
            // var pictureSizeArr = [
            //     'PICSIZE', // 列表图尺寸
            //     'PICBIGSIZE', // 大图尺寸
            //     'FOCUSIMAGESIZE', // 焦点图尺寸
            //     'PICZTPICSIZE', // 窄图
            // ];
            // trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            //     $scope.status.pictureSize = {};
            //     pictureSizeArr.forEach(function(value, item) {
            //         $scope.status.pictureSize[value] = data[value] = !data[value] ? '100,100' : data[value];
            //         var arr = [];
            //         if (value === 'PICSIZE') {
            //             arr = data[value].split(',');
            //             $scope.data.listPicRatio.set = {
            //                 0: (arr[0] / arr[1]).toFixed(2),
            //                 1: (arr[0] / arr[1]).toFixed(2),
            //                 2: (arr[0] / arr[1]).toFixed(2),
            //             };
            //         }
            //         if (value === 'FOCUSIMAGESIZE') {
            //             arr = data[value].split(',');
            //             $scope.data.focusRatio.set = (arr[0] / arr[1]).toFixed(2);
            //         }
            //         if (value === 'PICBIGSIZE') {
            //             arr = data[value].split(',');
            //             $scope.data.bigPicRtion.set = (arr[0] / arr[1]).toFixed(2);
            //         }
            //         if (value === 'PICZTPICSIZE') {
            //             arr = data[value].split(',');
            //             $scope.data.specZtPicRtion.set = (arr[0] / arr[1]).toFixed(2);
            //         }
            //     });
            // });

        }

        /**
         * [getFusionEditorCutPictureWidthHeight description]给融合编辑器添加一个默认的比例
         * @return {[type]} [description]
         */
        function getFusionEditorCutPictureWidthHeight() {
            var pictureSizeArr = [
                'PICSIZE', // 列表图尺寸
                'PICBIGSIZE', // 大图尺寸
                'FOCUSIMAGESIZE', // 焦点图尺寸
                'PICZTPICSIZE', // 窄图
            ];
            var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr);
            // 将返回来的值进行复制到本身控制器里显示
            dealPictureSize(pictureSizeArr, pictureSizeObj);

            // $scope.status.pictureSize = {};
            // // 列表图比例默认4:3
            // $scope.status.pictureSize.PICSIZE = '4,3';
            // // 焦点图比例默认16:9
            // $scope.status.pictureSize.FOCUSIMAGESIZE = '16,9';
            // // 大图比例默认16:9
            // $scope.status.pictureSize.PICBIGSIZE = '16,9';
            // // 窄图比例690：160
            // $scope.status.pictureSize.PICZTPICSIZE = '690,160';
            // $scope.data.listPicRatio.set = {
            //     0: (4 / 3).toFixed(2),
            //     1: (4 / 3).toFixed(2),
            //     2: (4 / 3).toFixed(2),
            // };
            // $scope.data.focusRatio.set = (16 / 9).toFixed(2);
            // $scope.data.bigPicRtion.set = (16 / 9).toFixed(2);
            // $scope.data.specZtPicRtion.set = (690 / 160).toFixed(2);
        }

        /**
         * [dealPictureSize description]处理图片返回的比例操作
         *
         * @param   {[type]}  pictureSizeArr  [pictureSizeArr description]
         * @param   {[type]}  pictureSizeObj  [pictureSizeObj description]
         *
         * @return  {[type]}                  [return description]
         */
        function dealPictureSize(pictureSizeArr, pictureSizeObj) {
            pictureSizeArr.forEach(function (value, item) {
                $scope.status.pictureSize[value] = pictureSizeObj[value];
            });
            // 定制gulp
            $scope.data.listPicRatio.set = pictureSizeObj.ratio.PICSIZE;
            $scope.data.focusRatio.set = pictureSizeObj.ratio.FOCUSIMAGESIZE;
            $scope.data.bigPicRtion.set = pictureSizeObj.ratio.PICBIGSIZE;
            $scope.data.specZtPicRtion.set = pictureSizeObj.ratio.PICZTPICSIZE;
        }

        /**
         * [getSiteConfig description]获取站点的配置信息
         * @return {[type]}           [description]
         */
        function getSiteConfig() {
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'findAppSiteById',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.manuAttr = {
                    relatedTopic: data.RELATEDTOPIC,
                    connectionColumn: data.CONNECTIONCOLUMN,
                    relatedOfficial: data.RELATEDOFFICIAL,
                };
                initRelatedColumnData();
                initRelatedOfficials();
            });
        }

        /**
         * [initRelatedOfficials description] 初始化相关官员
         * @return {[type]} [description]
         */
        function initRelatedOfficials() {
            if ($scope.status.manuAttr.relatedOfficial != 1) {
                return;
            }
            $scope.status.relatedOfficial = !!(angular.isArray($scope.list.RELEVANTOFFICIALSIDS) && $scope.list.RELEVANTOFFICIALSIDS.length > 0);
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWOfficers',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.relatedOfficialList =
                    angular.isObject(resp) && angular.isObject(resp.DATA) && angular.isArray(resp.DATA.officer_list) ? resp.DATA.officer_list : [];
                if (!angular.isArray($scope.list.RELEVANTOFFICIALSIDS)) {
                    return;
                }
                $scope.data.selectedOfficial = $scope.data.relatedOfficialList.filter((item) =>
                    $scope.list.RELEVANTOFFICIALSIDS.some((_item) => _item == item.id)
                );
            });
        }

        /**
         * [closeRelatedOfficial description] 关闭相关官员选项
         * @return {[type]} [description]
         */
        $scope.closeRelatedOfficial = function () {
            if (!$scope.status.relatedOfficial) {
                $scope.status.relatedOfficial = true;
                if (!angular.isArray($scope.data.selectedOfficial)) {
                    return;
                }
                $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
            } else {
                $scope.status.relatedOfficial = false;
                $scope.list.RELEVANTOFFICIALSIDS = [];
            }
        };

        /**
         * [selectedOfficials description] 选中了相关官员
         * @return {[type]} [description]
         */
        $scope.selectedOfficials = function () {
            $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
        };

        /**
         * [initRelatedColumnData description] 初始化相关栏目数据，以适应级联菜单
         * @return {[type]} [description]
         */
        function initRelatedColumnData() {
            if ($scope.status.manuAttr.connectionColumn == 1) {
                $scope.status.relatedColumn = [
                    [
                        {
                            name: $scope.list.BELONGCHANNEL.TYPE,
                            id: $scope.list.BELONGCHANNEL.ID,
                        },
                        {
                            name: $scope.list.BELONGCHANNEL.NAME,
                            id: $scope.list.BELONGCHANNEL.VALUE,
                        },
                    ],
                ];
            }
        }

        /**
         * [getZJXWColumns description] 获取相关栏目列表
         * @return {[type]} [description]
         */
        $scope.getZJXWColumns = function () {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWColumns',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                let treeData = (() => {
                    if (
                        !angular.isObject(resp) ||
                        !angular.isObject(resp.DATA) ||
                        !angular.isArray(resp.DATA.all_columns) ||
                        resp.DATA.all_columns.length == 0
                    ) {
                        return [];
                    }
                    return resp.DATA.all_columns.map((item, index) => ({
                        id: item.id,
                        name: item.type,
                        CHILDREN: item.column_list.map((item_, index_) => {
                            item_.hasChildren = 0;
                            return item_;
                        }),
                    }));
                })();
                deffer.resolve(treeData);
            });
            return deffer.promise;
        };

        /**
         * [selectRelatedColumn description] 选中相关栏目
         * @return {[type]} [description]
         */
        $scope.selectRelatedColumn = function () {
            $scope.list.BELONGCHANNEL =
                angular.isArray($scope.status.relatedColumn) &&
                    angular.isArray($scope.status.relatedColumn[0]) &&
                    $scope.status.relatedColumn[0][1].id
                    ? {
                        ID: $scope.status.relatedColumn[0][0].id,
                        TYPE: $scope.status.relatedColumn[0][0].name,
                        NAME: $scope.status.relatedColumn[0][1].name,
                        VALUE: $scope.status.relatedColumn[0][1].id,
                    }
                    : {};
        };

        /**
         * [initEditData description]初始化编辑页数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                $scope.list = data;
                getZrbj();
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                if (!data.LISTSTYLE) {
                    $scope.list.LISTSTYLE = '2'; // 网站多元分发过来的新闻、链接、图集稿件，列表样式默认选择文字。
                }
                $scope.status.audioVideoidsArray = angular.copy($scope.list.VIDEOREL);
                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                getVersion();
                getPropagandaReview();
                reWriteImg(angular.copy($scope.list));
                initRelavantSpecialDoc();
                initKeyWords();
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                defer.resolve();
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return defer.promise;
        }

        /**
         * [initRelavantSpecialDoc description] 初始化相关专题
         * @return {[type]} [description]
         */
        function initRelavantSpecialDoc() {
            if (angular.isDefined($scope.list.RELEVANTSPECIALDOC) && $scope.list.RELEVANTSPECIALDOC.length != 0) {
                angular.forEach($scope.list.RELEVANTSPECIALDOC, function (data, index) {
                    $scope.data.relSubjectSelectedItems.push({
                        METADATAID: data.METADATAID,
                        LISTTITLE: data.LISTTITLE,
                        SPECIALGROUPID: data.SPECIALGROUPID,
                    });
                    $scope.data.relSubjectSelectedGroup.push({
                        name: data.SPECIALGROUPNAME,
                        value: data.SPECIALGROUPID,
                    });
                });
                var i = 0;
                initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
            }

            /**
             * [initRelSubjectGroup description] 初始化相关专题稿件的分组
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function initRelSubjectGroup(item) {
                var params = {
                    methodname: 'querySpecialGroupsFromData',
                    serviceid: 'mlf_specialgroup',
                    MetaDataId: item.METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.relSubjectGroup[i] = data.DATA;
                    angular.forEach($scope.data.relSubjectGroup[i], function (value, key) {
                        value.name = value.SPECIALGROUPNAME;
                        value.value = value.SPECIALGROUPID;
                    });
                    i++;
                    if (i < $scope.list.RELEVANTSPECIALDOC.length) {
                        initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
                    }
                });
            }
        }

        /**
         * [initNewData description]初始化新建页数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var deffer = $q.defer();
            $scope.list = initAddMetaDataService.initAtlas();
            $scope.list.ORIGINAL = '0';
            getZrbj();
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.list.LABEL = list.length === 0 ? '' : list[0].value;

                /* getRelevantOfficials();
            getBelongChannel();*/
                deffer.resolve();
            });
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            return deffer.promise;
        }

        /**
         * [reWriteImg description]回写图片列表数据
         *
         * @param   {[type]}  list  [list description]
         *
         * @return  {[type]}        [return description]
         */
        function reWriteImg(list) {
            var imgArray = ['DOC_PICTURELIST', 'FOCUSIMAGE', 'LISTPICS'];
            angular.forEach(imgArray, function (data, index) {
                if (list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach(list[data], function (dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                            APPENDIXID: dataC.APPENDIXID,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        /**
         * [checkReleOfficials description] 相关官员开关
         * @return {[type]} [description]
         */
        /* $scope.checkReleOfficials = function() {
        if ($scope.status.hasReleOfficials === true) {
            $scope.status.hasReleOfficials = false;
        } else {
            $scope.status.hasReleOfficials = true;
        }
    };*/

        /**
         * [showReleOfficialsValue description] 用于页面表单校验相关官员是否有数据
         * @return {[type]} [description]
         */
        $scope.showReleOfficialsValue = function () {
            $scope.data.releOfficialsValue = trsspliceString.spliceString($scope.data.selectedReleOfficials, 'ID', ',');
        };

        // 可视化选择弹窗
        $scope.visualChooseWindow = function (type) {
            trsSelectDocumentService.trsSelectDocument(
                {
                    siteid: $state.params.appsiteid,
                    relNewsData: type == 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                    position: $state.params.appplatform,
                    showMetadaId: true,
                    isApp: true,
                    docType: '2',
                    searchSpecialDoc: type == 'relSubjectSelectedItems',
                    platform: 7,
                },
                function (result) {
                    if (type == 'relNewsSelectedItems') {
                        angular.forEach(result, function (value, key) {
                            value.METADATAID = value.metadataId;
                            value.LISTTITLE = value.title;
                        });
                        $scope.data[type] = result;
                    } else {
                        var i = 0;
                        var index = $scope.data[type].length;
                        var hasGroupArray = [];
                        queryRelSubjectGroup(result[i], function () {
                            $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                        });
                    }

                    /**
                     * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                     * @param  {[type]}   item     [description] 当前稿件
                     * @param  {Function} callback [description] 回调函数
                     * @return {[type]}            [description]
                     */
                    function queryRelSubjectGroup(item, callback) {
                        item.METADATAID = item.metadataId;
                        item.LISTTITLE = item.title;
                        var params = {
                            methodname: 'querySpecialGroupsFromData',
                            serviceid: 'mlf_specialgroup',
                            MetaDataId: item.METADATAID,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                            if (data.DATA.length === 0) {
                                modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                i++;
                            } else {
                                $scope.data.relSubjectGroup[index] = data.DATA;
                                angular.forEach($scope.data.relSubjectGroup[index], function (value, key) {
                                    value.name = value.SPECIALGROUPNAME;
                                    value.value = value.SPECIALGROUPID;
                                });
                                $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                hasGroupArray.push(item);
                                i++;
                                index++;
                            }
                            if (i < result.length) {
                                queryRelSubjectGroup(result[i], callback);
                            } else {
                                callback();
                            }
                        });
                    }
                }
            );
        };

        /**
         * [queryRelatedNewsByKeyWords description] 查询相关新闻
         * @return {[type]} [description]
         */
        $scope.queryRelatedNewsByKeyWords = function () {
            var DocId = $state.params.appmetadataid ? $state.params.appmetadataid : 0;
            var keywords = [];
            keywords = trsspliceString.spliceString(angular.copy($scope.data.KEYWORDS), 'name', ';');
            if (keywords == '') {
                modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'queryRelatedNewsByKeyWords',
                MetaDataId: DocId,
                ChannelId: $state.params.appchannelid,
                KeyWords: keywords,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var ralNewsLen = angular.copy($scope.data.relNewsSelectedItems).length;
                if (ralNewsLen >= 5) {
                    return;
                }
                $scope.data.relNewsSelectedItems = darftRemove($scope.data.relNewsSelectedItems, data, 'METADATAID').splice(0, 5);
                if ($scope.data.relNewsSelectedItems.length == 0) {
                    modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                }
            });
        };

        /**
         * [darftRemove description]  数组去重
         * @param  {[type]} selectArray [description]  当前数组
         * @param  {[type]} dataArray   [description]   再次请求出数组
         * @param  {[type]} type [description]
         * @param  {[type]} callback   [description]
         * @return {[type]}             [description]
         */
        function darftRemove(selectArray, dataArray, type, callback) {
            var arr = selectArray.concat(dataArray);
            var lastArr = [];
            var num = 0;
            for (var i = 0; i < arr.length; i++) {
                if (!unique(arr[i][type], lastArr, type)) {
                    lastArr.push(arr[i]);
                } else {
                    if (angular.isFunction(callback)) {
                        callback(i - num);
                        num++;
                    }
                }
            }
            return lastArr;
        }

        /**
         * [unique description]
         *
         * @param   {[type]}  n     [n description]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        function unique(n, arr, type) {
            for (var i = 0; i < arr.length; i++) {
                if (n == arr[i][type]) {
                    return true;
                }
            }
            return false;
        }

        // 选择相关新闻或专题
        $scope.selectManuscript = function (item, type) {
            if (type == 'relNewsSelectedItems') {
                if ($scope.data.selectNewArray.indexOf(item) < 0) {
                    $scope.data.selectNewArray.push(item);
                } else {
                    $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                }
            } else {
                if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                    $scope.data.selectSubjectArray.push(item);
                } else {
                    $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
                }
            }
        };

        /**
         * [selectAll description]稿件全选
         *
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectAll = function (type) {
            if (type == 'selectSubjectArray') {
                $scope.data.selectSubjectArray =
                    $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                        ? []
                        : [].concat($scope.data.relSubjectSelectedItems);
            } else {
                $scope.data.selectNewArray =
                    $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length ? [] : [].concat($scope.data.relNewsSelectedItems);
            }
        };

        /**
         * [manuscriptDelete description]删除已选稿件
         *
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.manuscriptDelete = function (type) {
            var index;
            if (type == 'relSubjectSelectedItems') {
                for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                    index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                    $scope.data.relSubjectSelectedItems.splice(index, 1);
                }
                $scope.data.selectSubjectArray.length = 0;
            } else {
                for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                    index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                    $scope.data.relNewsSelectedItems.splice(index, 1);
                }
                $scope.data.selectNewArray.length = 0;
            }
        };

        /**
         * [selectRelSubjectGroup description]选择相关专题稿件的分组
         *
         * @param   {[type]}  item           [item description]
         * @param   {[type]}  selectedGroup  [selectedGroup description]
         *
         * @return  {[type]}                 [return description]
         */
        $scope.selectRelSubjectGroup = function (item, selectedGroup) {
            item.SPECIALGROUPID = selectedGroup.value;
        };

        // 清空相关联稿件
        $scope.cleanRelatedNews = function (type) {
            $scope.data[type] = [];
            if (type == 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup = [];
                $scope.data.relSubjectSelectedGroup = [];
            }
        };

        // 删除相关新闻或专题
        $scope.relNewsDelete = function (curIndex, type) {
            var index = $scope.data[type].indexOf(curIndex);
            $scope.data[type].splice(index, 1);
            if (type == 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            }
        };

        // 空格增加关键词
        $scope.blank = function (e) {
            if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                $scope.list.KEYWORDS.push($scope.keywordTxt);
                $scope.keywordTxt = '';
            }
        };
        // 删除关键词
        $scope.delete = function (record) {
            $scope.list.KEYWORDS.splice(record, 1);
        };
        // 检验关键词的总个数和总记录长度
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };
        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function () {
            // $scope.isShowKeywordTips = false;
        };
        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }

            /* if (angular.isDefined($scope.keywordsTips) && $scope.keywordsTips !== "") {
            $scope.isShowKeywordTips = true;
        }*/
        };

        /**
         * [initKeyWords description]初始化关键词开始
         *
         * @return  {[type]}  [return description]
         */
        function initKeyWords() {
            if ($scope.list.KEYWORDS) {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }

        /**
         * [getKeyWords description]获取关键词
         * @return {[type]} [description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [deleteUploaderImg description]删除上传后的图片app
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function (attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /* 批量上传图片模态框*/
        $scope.multiImgsUploader = function () {
            let options = {
                resourceType: '0',
                isMulti: true,
            };
            editingCenterService.mediaSelector(options).then(function (result) {
                var picList = [];
                for (var l = 0; l < result.list.length; l++) {
                    // 我的图片已经选中的
                    var imgName = result.list[l].previewurl.substring(result.list[l].previewurl.lastIndexOf('/') + 1).split('?')[0];
                    picList.push({
                        PERPICURL: result.list[l].resourceurl,
                        APPFILE: imgName,
                        APPDESC: result.list[l].resourcetitle,
                        APPSIZE: result.list[l].resourcesize,
                        meiziId: result.list[l].resourceid,
                        relationId: result.list[l].relationid,
                    });
                }
                $scope.list.DOC_PICTURELIST = $scope.list.DOC_PICTURELIST.concat(picList);
            });
        };
        // 批量删除上传后的图片
        $scope.batchDelete = function () {
            modalDialog.confirmModal('删除', '是否确认删除选择的图片', function () {
                var temp = [];
                angular.forEach($scope.list.DOC_PICTURELIST, function (data, index, array) {
                    if ($scope.status.uploaderImgSelected.indexOf(data) < 0) {
                        temp.push(data);
                    }
                });
                $scope.list.DOC_PICTURELIST = temp;
                $scope.status.uploaderImgSelected = [];
            });
        };
        // 全选批量上传后的图片
        $scope.selectAllImg = function () {
            $scope.status.uploaderImgSelected =
                $scope.status.uploaderImgSelected.length === $scope.list.DOC_PICTURELIST.length ? [] : [].concat($scope.list.DOC_PICTURELIST);
        };
        // 选择批量上传后的图片
        $scope.selectImg = function (item) {
            if ($scope.status.uploaderImgSelected.indexOf(item) < 0) {
                $scope.status.uploaderImgSelected.push(item);
            } else {
                $scope.status.uploaderImgSelected.splice($scope.status.uploaderImgSelected.indexOf(item), 1);
            }
        };
        // 选择批量上传后的图片结束
        // 单个删除批量上传后的图片
        $scope.deleteImg = function (ID) {
            modalDialog.confirmModal('删除', '确定删除？', function () {
                var temp = [];
                for (var i = 0; i < $scope.list.DOC_PICTURELIST.length; i++) {
                    if (i != ID) {
                        temp.push($scope.list.DOC_PICTURELIST[i]);
                    }
                }
                $scope.list.DOC_PICTURELIST = temp;
                // $scope.list.DOC_PICTURELIST.splice(ID, 1);
            });
        };

        /**
         * [multiImgsDownload description] 下载原图
         * @return {[type]} [description]
         */
        $scope.multiImgsDownload = function () {
            $scope.loadingPromise = editingCenterService.downloadOrgImgList($scope.status.uploaderImgSelected, 'PERPICURL', 'APPDESC');
        };

        /**
         * [moveUploadImg description]图集上传图片列表拖拽
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.moveUploadImg = function (index) {
            $scope.list.DOC_PICTURELIST.splice(index, 1);
        };
        // 说明引用到全部
        $scope.declareAll = function (index) {
            modalDialog.confirmModal('同步', '确定同步该说明到其它图片？', function () {
                var text = $scope.list.DOC_PICTURELIST[index].APPDESC;
                angular.forEach($scope.list.DOC_PICTURELIST, function (data, key) {
                    $scope.list.DOC_PICTURELIST[key].APPDESC = text;
                });
            });
        };
        // 将图集图片设置为列表图
        $scope.setImgAsCover = function (index) {
            if (isListPicfilled()) {
                modalDialog.alertType('列表图已填充满', '', 'warning', 'confirm');
                return;
            }
            let img = $scope.list.DOC_PICTURELIST[index];
            var fileObj = {
                imgName: img.APPFILE,
                imgSrc: img.PERPICURL,
            };
            if ($scope.status.pictureSize) {
                let pictureSize = getCurrentPictureSize();
                if (editPictureService.isGif(img.PERPICURL)) {
                    editPictureService.isCbilionformRatio(img.PERPICURL, pictureSize, '列表图').then(function() {
                        fillListPic(fileObj);
                    });
                    return;
                }
                editPictureService.newCropperApp(fileObj, pictureSize).then(
                    function (src) {
                        fillListPic(src);
                    },
                    function () {
                        //
                    }
                );
            } else {
                fillListPic(img);
            }
        };

        /**
         * [getCurrentPictureSize description]获取当前列表图类型的图片尺寸
         *
         * @return  {[type]}  [return description]
         */
        function getCurrentPictureSize() {
            let pictureSize;
            switch (parseInt($scope.list.LISTSTYLE)) {
                case 0:
                case 1:
                    pictureSize = $scope.status.pictureSize.PICSIZE;
                    break;
                case 3:
                    pictureSize = $scope.status.pictureSize.PICBIGSIZE;
                    break;
                case 4:
                    pictureSize = $scope.status.pictureSize.PICZTPICSIZE;
                    break;
                default:
                    pictureSize = $scope.status.pictureSize.PICSIZE;
            }
            return pictureSize;
        }

        /**
         * [isListPicfilled description]判断列表图是否已经填充满
         *
         * @return  {[type]}  [return description]
         */
        function isListPicfilled() {
            let isFilled = true;
            if (!$scope.list.LISTPICS.length) {
                return false;
            } else {
                let length = parseInt($scope.list.LISTSTYLE) === 1 ? 3 : 1;
                for (var i = 0; i < length; i++) {
                    let item = $scope.list.LISTPICS[i];
                    if (!item) {
                        $scope.list.LISTPICS.push({
                            APPFILE: '',
                            APPDESC: '',
                            PERPICURL: '',
                        });
                    }
                    if (!$scope.list.LISTPICS[i].APPFILE) {
                        isFilled = false;
                    }
                }
            }
            return isFilled;
        }

        /**
         * [fillListPic 填充列表图]
         *
         * @param   {[type]}  src  [src description]
         *
         * @return  {[type]}       [return description]
         */
        function fillListPic(src) {
            if (!$scope.list.LISTPICS.length) {
                $scope.list.LISTPICS.push(
                    {
                        APPFILE: src.imgName || src.APPFILE,
                        APPDESC: src.imgName || src.APPDESC,
                        PERPICURL: src.imgSrc || src.PERPICURL,
                    }
                );
                editingCenterAppService.getImgSize($scope.list.LISTPICS[0].PERPICURL).then(function (size) {
                    $scope.data.listPicRatio.practical[0] = size;
                });
            } else {
                let insertIndex = 0;
                let hasInsert = false;
                for (var i = 0; i < $scope.list.LISTPICS.length; i++) {
                    let item = $scope.list.LISTPICS[i];
                    if (!item || !item.APPFILE && !hasInsert) {
                        $scope.list.LISTPICS[i] = {
                            APPFILE: src.imgName || src.APPFILE,
                            APPDESC: src.imgName || src.APPDESC,
                            PERPICURL: src.imgSrc || src.PERPICURL,
                        };
                        hasInsert = true;
                        insertIndex = i;
                    }
                }
                editingCenterAppService.getImgSize($scope.list.LISTPICS[insertIndex].PERPICURL).then(function (size) {
                    $scope.data.listPicRatio.practical[insertIndex] = size;
                });
            }
        }

        // 图片上移开始
        $scope.upMove = function (index) {
            if (index !== 0) {
                swapItems($scope.list.DOC_PICTURELIST, index, index - 1);
            }
        };

        // 图片下移开始
        $scope.downMove = function (index) {
            if (index !== $scope.list.DOC_PICTURELIST.length - 1) {
                swapItems($scope.list.DOC_PICTURELIST, index, index + 1);
            }
        };

        /**
         * [swapItems description]
         *
         * @param   {[type]}  list    [list description]
         * @param   {[type]}  index1  [index1 description]
         * @param   {[type]}  index2  [index2 description]
         *
         * @return  {[type]}          [return description]
         */
        function swapItems(list, index1, index2) {
            list[index1] = list.splice(index2, 1, list[index1])[0];
        }

        // 图片固定位置
        /* $scope.fixed = function(index, uploaderImg) {
        editingCenterService.atlasFixed(index + 1, $scope.list.DOC_PICTURELIST.length).then(function(data) {
            $scope.list.DOC_PICTURELIST.splice(index, 1);
            $scope.list.DOC_PICTURELIST.splice(data - 1, 0, uploaderImg);
        });
    };*/
        /**
         * [editImage description]编辑图片模态窗
         * @param  {[obj]} image [description]被选中的图片
         * @param  {[num]} index [description]数组下标
         * @return {[type]}       [description]
         */
        $scope.editImage = function (image, index) {
            // editingCenterService.editUploaderImg(image, function(result) {
            //     $scope.list.DOC_PICTURELIST[index].PERPICURL = result.PERPICURL;
            //     $scope.list.DOC_PICTURELIST[index].APPFILE = result.APPFILE;
            //     $scope.list.DOC_PICTURELIST[index].APPDESC = result.APPDESC;
            //     delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
            // });
            // 对接媒资库
            let options = {
                resourceType: '0',
                isMulti: false,
            };
            editingCenterService.mediaSelector(options).then(function (result) {
                var imgName = result.list[0].previewurl.substring(result.list[0].previewurl.lastIndexOf('/') + 1).split('?')[0];
                $scope.list.DOC_PICTURELIST[index] = {
                    PERPICURL: result.list[0].resourceurl,
                    APPFILE: imgName,
                    APPDESC: result.list[0].resourcetitle,
                    APPSIZE: result.list[0].resourcesize,
                    meiziId: result.list[0].resourceid,
                    relationId: result.list[0].relationid,
                };
            });
        };

        /**
         * [photoCrop description]编辑裁剪图片
         *
         * @param   {[type]}  image  [image description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.photoCrop = function (image, index) {
            editPictureService.editPicture(angular.copy(image), $state.params.appsiteid, function (img) {
                $scope.list.DOC_PICTURELIST[index].APPFILE = img.imgName;
                $scope.list.DOC_PICTURELIST[index].PERPICURL = img.imgSrc;
                $scope.list.DOC_PICTURELIST[index].SRCFILE = img.srcFile;
                delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
            });
        };

        /**
         * [updateCKSelection description]trsCheckBox的回调函数
         * @param  {[str]} attribute [description]需要改变的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            // if (attribute === 'ISFOCUSIMAGE' && $state.params.appplatform === '2') {
            //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
            //     return;
            // }
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            if (!$scope.status.isFusionEditor) {
                editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                var draftList =
                    '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
        }

        /* 点击保存*/
        $scope.save = function (type) {
            // app
            type = angular.isDefined(type) ? type : true;
            var deffer = $q.defer();
            save(type).then(
                function (data) {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'appatlas') {
                        if (type === true) {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                        getVersion($scope.list.METADATAID);
                        var params;
                        if ($scope.status.isFusionEditor) {
                            params = {
                                serviceid: 'mlf_fusioncreate',
                                methodname: 'getAPPFusionDoc',
                                sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                            };
                        } else {
                            params = {
                                serviceid: 'mlf_appmetadata',
                                methodname: 'getPicsDoc',
                                ChnlDocId: $state.params.appchnldocid,
                            };
                        }
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                reWriteImg(data);
                                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                                deffer.resolve();
                            },
                            function () {
                                deffer.resolve();
                            }
                        );
                    } else {
                        deffer.resolve();
                    }
                },
                function () {
                    deffer.reject();
                }
            );
            return deffer.promise;
        };

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function () {
            trial();
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                save().then(function () {
                    let trialParams = angular.extend({
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.trialParams);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });
            // modalDialog.inputModel(
            //     '送审',
            //     '请输入送审意见',
            //     function(content) {
            //         var params = {
            //             serviceid: 'mlf_appoper',
            //             methodname: 'trialMetaDatas',
            //             MetaDataIds: $scope.list.METADATAID,
            //             ChnlDocIds: $scope.list.CHNLDOCID,
            //             ChannelId: $state.params.appchannelid,
            //             Opinion: content,
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
            //             function(data) {
            //                 modalDialog.alertType(
            //                     '送审成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function() {
            //                         storageListenerService.addListenerToApp('send');
            //                         $window.close();
            //                     },
            //                     '',
            //                     1500
            //                 );
            //             },
            //             function() {
            //                 editIsLock.lockDraft($state.params.appmetadataid);
            //             }
            //         );
            //     },
            //     '',
            //     function() {
            //         editIsLock.lockDraft($state.params.appmetadataid);
            //     }
            // );
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function () {
            signDirect();
        };

        /**
         * [signDirect description]直接签发
         *
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         *
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function () {
                        signPrivate();
                    },
                    function () {
                        signPrivate();
                    }
                );
            }
        }

        /**
         * [signPrivate description]
         *
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function () {
                save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能定时签发', 'warning', 'confirm');
                return;
            }
            timeSign();
        };

        /**
         * [timeSign description]定时签发函数
         * @return {[type]} [description]
         */
        function timeSign() {
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function () {
            $scope.save(false).then(function (data) {
                editIsLock.lockDraft($state.params.appmetadataid);
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function () {
                },
                function () {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function () {
            // save().then(function(data) {
            revoke();
            // });
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                save().then(function () {
                    let KillParams = angular.extend({
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.rejectionParams);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
            // modalDialog.inputModel(
            //     '撤稿',
            //     '撤稿原因（选填）',
            //     function(content) {
            //         var params = {
            //             serviceid: 'mlf_appoper',
            //             methodname: 'rejectionMetaDatas',
            //             ChnlDocIds: $scope.list.CHNLDOCID,
            //             MetaDataIds: $scope.list.METADATAID,
            //             Opinion: content,
            //             ChannelId: $state.params.appchannelid,
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
            //             function() {
            //                 modalDialog.alertType(
            //                     '撤稿成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function() {
            //                         $scope.status.isSignedOrRevoked = true;
            //                         storageListenerService.addListenerToApp('revoke');
            //                         $window.close();
            //                     },
            //                     '',
            //                     1500
            //                 );
            //             },
            //             function() {
            //                 editIsLock.lockDraft($state.params.appmetadataid);
            //             }
            //         );
            //     },
            //     '',
            //     function() {
            //         editIsLock.lockDraft($state.params.appmetadataid);
            //     }
            // );
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function () {
            // save().then(function(data) {
            signDirect(true);
            // });
        };

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                save().then(
                    function () {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $state.params.appmetadataid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function () {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500
                                );
                            },
                            function (data) {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            }
                        );
                    },
                    function () {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    }
                );
            });
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function () {
            if ($scope.status.editVideoTranscoding) {
                aboutVideoCloseView('温馨提示', '有编辑完成的视频正在转码中，关闭将无法保存，是否直接关闭？', 'error', true);
            } else if (isVideoArrayChanged()) {
                aboutVideoCloseView('温馨提示', '视频有更改，关闭将无法保存，是否直接关闭？', 'warning', true);
            } else {
                closeCurrView();
            }
        };

        /**
         * [closeCurrView description]关闭页面方法
         *
         * @return  {[type]}  [return description]
         */
        function closeCurrView() {
            editingCenterService.closeWinow($scope.atlasForm.$dirty, false).then(
                function () {
                    save().then(function () {
                        storageListenerService.addListenerToApp('save');
                        editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                            $window.open('about:blank', '_self').close();
                        });
                    });
                },
                function () {
                    angular.isDefined($state.params.appmetadataid)
                        ? editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                            $window.open('about:blank', '_self').close();
                        })
                        : $window.open('about:blank', '_self').close();
                }
            );
        }

        /**
         * [aboutVideoCloseView description]被视频影响的衍生出来的关闭页面方法（含提醒）
         *
         * @param   {[type]}  bigWord       [bigWord description]
         * @param   {[type]}  smallWord     [smallWord description]
         * @param   {[type]}  status        [status description]
         * @param   {[type]}  hasCancelBtn  [hasCancelBtn description]
         *
         * @return  {[type]}                [return description]
         */
        function aboutVideoCloseView(bigWord, smallWord, status, hasCancelBtn) {
            if ($scope.atlasForm.$dirty) {
                closeCurrView();
            } else {
                modalDialog.alertType(bigWord, smallWord, status, hasCancelBtn, function () {
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                });
            }
        }

        /**
         * [manangeListBeforeSave description]保存前检查图片
         * @return {[type]} [description]
         */
        function manangeListBeforeSave() {
            $validation.validate($scope.atlasForm.authorForm);
            $scope.atlasForm.$pending = {};
        }

        /**
         * [dealAttribute description]处理属性
         * @return {[obj]} [description]list对象
         */
        function dealAttribute() {
            getKeyWords();
            $scope.list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
            $scope.list.SPECIALMANUSCRIPT = $scope.data.specialManuscript;
            // 根据列表样式过滤多余的图片信息
            if ($scope.list.LISTSTYLE == '2') {
                $scope.list.LISTPICS = [];
            } else if ($scope.list.LISTSTYLE == '0') {
                $scope.list.LISTPICS = [].concat(angular.copy($scope.list.LISTPICS[0]));
            }
            getRelavantSpecialDoc();
            $scope.list.CUSTOMTIME = globleParamsSet.filterTime($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm');
            var list = angular.copy($scope.list);
            calculateWordNum(list);
            $scope.status.openBtn = false;
            list.LISTPICS = angular.copy(jsonArrayToStringService.clearEmptyArray(list.LISTPICS));
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            if ($scope.status.isFusionEditor) {
                delete list.ISNOPAYMENT;
                delete list.FGD_EDITINFO;
                delete list.FGD_AUTHINFO;
                delete list.DOCGENRE;
                list.METADATAID = $state.params.appmetadataid || '0';
                list.serviceid = 'mlf_fusionapp';
                list.methodname = 'saveFictitionsPicsDoc';
                list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
            } else {
                list.serviceid = 'mlf_appmetadata';
                list.methodname = 'savePicsDoc';
            }
            list.PICTURELIST = list.DOC_PICTURELIST; // PICTURELIST是做新媒体渠道时添加的，为了兼容性，需把两边的值保持一致
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [calculateWordNum description]计算图集稿字数,图集说明字数+各图说字数,但图集说明中的字数为图集说明中输入的字数不为图集稿总字数
         *
         * @param   {[type]}  list  [list description]
         *
         * @return  {[type]}        [return description]
         */
        function calculateWordNum(list) {
            var len = 0;
            angular.forEach($scope.list.DOC_PICTURELIST, function (value, key) {
                if (angular.isDefined(value.APPDESC)) {
                    len += value.APPDESC.length;
                }
            });
            list.DOCWORDSCOUNT = len;
        }

        /**
         * [getRelavantSpecialDoc description] 获取相关专题
         * @return {[type]} [description]
         */
        function getRelavantSpecialDoc() {
            darftRemove($scope.data.relSubjectSelectedItems, [], 'SPECIALGROUPID', function (index) {
                $scope.data.relSubjectSelectedItems.splice(index, 1);
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            });
            $scope.list.RELEVANTSPECIALDOC = [];
            angular.forEach($scope.data.relSubjectSelectedItems, function (data, index) {
                $scope.list.RELEVANTSPECIALDOC.push({
                    METADATAID: data.METADATAID,
                    SPECIALGROUPID: data.SPECIALGROUPID,
                });
            });
            $scope.list.RELEVANTSPECIALDOC = jsonArrayToStringService.clearEmptyArray($scope.list.RELEVANTSPECIALDOC);
        }

        /**
         * [manageListAfterSave description]保存后处理数据
         * @param  {[obj]} data [description]保存后的返回值
         * @param  {[boolean]} flag [description]标志位
         * @return {[type]}      [description]
         */
        function manageListAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $scope.status.isEditDraft = true;
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.appmetadataid = angular.isDefined($state.params.appmetadataid) ? $state.params.appmetadataid : data.METADATAID;
            $state.params.appchnldocid = angular.isDefined($state.params.appchnldocid) ? $state.params.appchnldocid : data.CHNLDOCID;
            $state.params.appchannelid = angular.isDefined($state.params.appchannelid) ? $state.params.appchannelid : $scope.list.CHANNELID;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToApp('save');
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    $timeout(function () {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params = {
                    serviceid: 'mlf_appoper',
                    ChannelId: $scope.list.CHANNELID,
                    ChnlDocIds: data.CHNLDOCID,
                    ObjectIds: data.CHNLDOCID,
                    MetaDataIds: data.METADATAID,
                };
            }
        }

        /**
         * [examImg description]图集稿必须上传图片
         * @return {[boolean]} [description]标识位
         */
        function examImg() {
            var flag = $scope.list.DOC_PICTURELIST.length != 0;
            return flag;
        }

        /**
         * [save description]保存函数
         *
         * @param   {[type]}  flag  [flag description]
         *
         * @return  {[type]}        [return description]
         */
        function save(flag) {
            var deferred = $q.defer();
            manangeListBeforeSave();
            $scope.atlasForm.$pending = {};
            $validation
                .validate($scope.atlasForm)
                .success(function () {
                    editingCenterAppService
                        .examineImageRatio($scope.list, $scope.data, $scope.status, 'PICSIZE', 'PICBIGSIZE', 'PICZTPICSIZE')
                        .then(function () {
                            modalDialog.isSecretInformation(
                                $state.params.appmetadataid,
                                function () {
                                    sensitiveWordCheckService.sensitiveWords($scope).then(
                                        function (sensitiveWords) {
                                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                                            $scope.atlasForm.$setPristine();
                                            var list = dealAttribute();
                                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                                function (data) {
                                                    manageListAfterSave(data, flag);
                                                    beforeonload.refresh($scope);
                                                    deferred.resolve(data);
                                                },
                                                function (data) {
                                                    $scope.status.openBtn = true;
                                                    deferred.reject(data);
                                                }
                                            );
                                        },
                                        function () {
                                            $scope.status.isCheckSensitiveWords = Math.random();
                                            deferred.reject();
                                        }
                                    );
                                },
                                function () {
                                    deferred.reject();
                                },
                                $scope.status.isFusionEditor
                            );
                        });
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.atlasForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject({
                        plat: 'APP'
                    });
                });
            // } else {
            //     deferred.reject();
            // }
            return deferred.promise;
        }

        /**
         * [getVersion description]获取流程版本与操作日志
         *
         * @param   {[type]}  id  [id description]
         *
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var metadataid = angular.isDefined(id) ? id : $state.params.appmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
            });
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [getPropagandaReview description]获取宣传部评审流程
         *
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [initBtnArray description]初始化功能按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function (data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    // 最终得到的按钮
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    checkSiteCanSaveAndPub().then(function () {
                        addBtn();
                    });
                });
            });
        }

        /**
         * [checkSiteCanSaveAndPub description] 校验站点是否设置了不显示“保存并发布”按钮
         * @return {[type]} [description]
         */
        function checkSiteCanSaveAndPub() {
            var defer = $q.defer();
            if ($state.params.appplatform == 2) {
                var params = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'canSaveAndPub',
                    SiteId: $state.params.appsiteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    var isNotShow = data.substring(1, data.indexOf('"', 1));
                    if (isNotShow == 'true') {
                        var hasPubSave = false;
                        var hasPubSaveIndex;
                        angular.forEach($scope.data.arrayBtn, function (value, key) {
                            // 判断是否含有保存并发布按钮
                            if (value.RIGHTINDEX == 419) {
                                hasPubSave = true;
                                hasPubSaveIndex = key;
                            }
                        });
                        if (hasPubSave === true) {
                            // 在已签发平台删除保存并发布按钮
                            $scope.data.arrayBtn.splice(hasPubSaveIndex, 1);
                        }
                    }
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [addBtn description]新增保存关闭按钮
         *
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
            // $scope.data.arrayBtn.push({
            //     RIGHTINDEX: "close",
            //     OPERDESC: "关闭",
            //     OPERNAME: "",
            //     OPERFUN: "close"
            // });
        }

        /**
         * [appSecondReview description] 已签发平台二次送审
         * @return {[type]} [description]
         */
        $scope.appSecondReview = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                return;
            }
            modalDialog.confirmModal('二次送审', '确认送审稿件', function () {
                appSecondReview();
            });
        };

        /**
         * [appSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
         * @param  {[type]} metadataid [description]
         * @return {[type]}            [description]
         */
        function appSecondReview() {
            if (isUploadingZJSJ()) {
                modalDialog.alertType('保存失败', '有上传至新疆视界的文件正在转码中', 'error', false);
                return;
            }
            var isHasImg = examImg();
            if (isHasImg) {
                manangeListBeforeSave();
                $scope.atlasForm.$pending = {};
                $validation
                    .validate($scope.atlasForm)
                    .success(function () {
                        sensitiveWordCheckService.sensitiveWords($scope).then(
                            function (sensitiveWords) {
                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                angular.forEach($scope.list.DOC_PICTURELIST, function (value, key) {
                                    if (angular.isDefined(value.APPENDIXID)) {
                                        delete value.APPENDIXID;
                                    }
                                });
                                $scope.atlasForm.$setPristine();
                                var list = dealAttribute();
                                list.serviceid = 'mlf_appoper';
                                list.methodname = 'makeNewDuplication';
                                list.MetaDataId = list.METADATAID;
                                list.ChannelId = list.CHANNELID;
                                delete list.METADATAID;
                                delete list.CHANNELID;
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                    function (data) {
                                        if (data.ISSUCCESS == 'true') {
                                            modalDialog.alertType(
                                                '二次送审成功',
                                                '',
                                                'success',
                                                false,
                                                function () {
                                                    $scope.status.isSecondReview = true;
                                                    storageListenerService.addListenerToApp('secondReview');
                                                    $window.close();
                                                },
                                                '',
                                                1500
                                            );
                                        } else {
                                            modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                        }
                                    },
                                    function (data) {
                                        $scope.status.openBtn = true;
                                        modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                    }
                                );
                            },
                            function () {
                                $scope.status.isCheckSensitiveWords = Math.random();
                            }
                        );
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.atlasForm); // 定位输入错的表单位置
                    });
            }
        }

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.appchnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [deleteAudioVideo description] 删除音视频
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.deleteAudioVideo = function (item) {
            modalDialog.confirmModal('删除音视频', '确定要删除选中的音/视频？', function () {
                $scope.data.selectedVideoArray = [];
                for (var j = 0; j < $scope.status.audioVideoidsArray.length; j++) {
                    if (item.AUDIOVIDEOID === $scope.status.audioVideoidsArray[j].AUDIOVIDEOID) {
                        $scope.status.audioVideoidsArray.splice(j, 1);
                        break;
                    }
                }
            });
        };

        /**
         * [highestMediaURL description]展示最高清的音视频
         *
         * @param   {[type]}  media  [media description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.highestMediaURL = function (media) {
            var highestMedia = media.value.streamsMap.h || media.value.streamsMap.m || media.value.streamsMap.l;
            return highestMedia.httpURL;
        };

        /**
         * [clickCommonAuthor description] 添加作者快速功能
         * @param  {[type]} keyword [description]
         * @return {[type]}         [description]
         */
        $scope.clickCommonAuthor = function (item) {
            $scope.list.SIGNATUREAUTHOR += item.text;
        };
        // 原创声明
        $scope.oringin = function (list) {
            if (list.ORIGINAL === '1') {
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.list.ORIGINAL = '1';
                $scope.data.originType = $scope.data.originList[0].value;
                $scope.data.specialDoc = 0;
            }
            // if (!$scope.status.nopayment) {
            //     $scope.status.nopayment = true;
            //     $scope.list.ISNOPAYMENT = '0';
            // }
        };
        // 点击特殊稿
        $scope.specialDoc = function () {
            if ($scope.data.specialDoc == 1) {
                $scope.data.specialDoc = 0;
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.data.specialDoc = 1;
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            }
        };
        // 勾选原创稿二级单选的原创类型
        $scope.checkOrigin = function (item) {
            $('.newsResourcesTips')
                .find('.tips')
                .remove();
            $scope.data.originType = item.value;
            $scope.list.ORIGINAL = '1';
            $scope.data.specialDoc = 0;
            // if (!$scope.status.nopayment) {
            //     $scope.status.nopayment = true;
            //     $scope.list.ISNOPAYMENT = '0';
            // }
        };

        /**
         * [multiImgsWatermark description]
         *
         * @return  {[type]}  [return description]
         */
        $scope.multiImgsWatermark = function () {
            editingCenterService.multiImgsWatermark($scope.status.uploaderImgSelected, $state.params.appsiteid).then((response) => {
                for (var i = 0; i < $scope.list.DOC_PICTURELIST.length; i++) {
                    if (response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE]) {
                        $scope.list.DOC_PICTURELIST[i].PERPICURL = response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE].FILEURL;
                        $scope.list.DOC_PICTURELIST[i].APPFILE = response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE].FILENAME;
                        $scope.list.DOC_PICTURELIST[i].APPENDIXID = 0;
                    }
                }
            });
        };

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {

            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function (type) {
                $timeout(function () {
                    if (type == 'manuscriptInfo') {
                        var manuHeight = $('.app_manuscript_info').height();
                        var manuWidth = $('.app_manuscript_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.app_manuscript_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type == 'attrInfo') {
                        var attrHeight = $('.app_attr_info').height();
                        var attrWidth = $('.app_attr_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.app_attr_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 融合编辑器切换渠道时的初始化数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            $scope.initData = function (dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($state.params.appchnldocid)) {
                    initEditData(dealWithListFun).then(function () {
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun);
                    defer.resolve();
                }
                return defer.promise;
            };

            /**
             * [loadFgd description] 加载发稿单
             * @return {[type]} [description]
             */
            $scope.loadFgd = function () {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };
        }
    },
]);
